// extracted by mini-css-extract-plugin
export default {"root":"_1ys9u_IFXWmMy8EO_5Q-zq","avatar":"_3_zZi5RlgfiRW_S_HLVYL_","totalImpact":"_3RBCSgOpGGkAWVUdEcT2Oa","name":"_3s30R39u-hX5aeSqXtBSCR"};